import { Box, Typography } from "@mui/material";
import DateInput from "components/Common/DateInput";
import isObjectEmpty from "helpers/isObjectEmpty";
import React, { useState } from "react";
import { CustomColumn } from "../..";
import { FILTER_TYPE_TILL } from "../filterTypes";
import { filterFieldStyles } from "./styling";

const SingleDateFilter = ({
  range,
  label,
  filters,
  setFilters,
  customColumns,
  disabled,
}: {
  range: Date[];
  label: string;
  filters: Record<string, any>;
  setFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  customColumns: CustomColumn;
  disabled?: boolean;
}) => {
  // Ensure the range[1] (max date) never exceeds today's date
  const today = new Date();
  const maxAllowedDate = range[1] > today ? today : range[1];
  
  const [minimumDate, setMinimumDate] = useState<Date | undefined>(
    filters[label]?.keywords[0] || range[0]
  );
  const [maximumDate, setMaximumDate] = useState<Date | undefined>(
    filters[label]?.keywords[1] || maxAllowedDate
  );
  
  const customColumnsExist = customColumns && !isObjectEmpty(customColumns);

  const clear = () => {
    setMinimumDate(range[0]);
    setMaximumDate(maxAllowedDate);
    const revertFilters = { ...filters };
    delete revertFilters[label];
    setFilters(revertFilters);
  };

  const displayLabel = customColumnsExist && customColumns?.[label]?.[label]
    ? customColumns?.[label]?.[label]
    : label;

  const currentYear = new Date().getFullYear();
  const yearRange = 50; // Show 50 years in the dropdown
  const startYear = currentYear - yearRange;
  
  // Generate an array of years for the year dropdown
  const years = Array.from(
    { length: yearRange + 1 },
    (_, i) => startYear + i
  );

  return (
    <Box sx={filterFieldStyles.container}>
      <Typography variant="subtitle2" sx={filterFieldStyles.label}>
        {displayLabel}
      </Typography>
      
      <Box sx={{
        ...filterFieldStyles.dateContainer,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }}>
        <DateInput
          disabled={disabled}
          label="From"
          value={minimumDate}
          setValue={setMinimumDate}
          onChangeCommitted={(date) => {
            setFilters((prev) => ({
              ...prev,
              [label]: {
                comparator: FILTER_TYPE_TILL,
                keywords: [date, maximumDate],
              },
            }));
          }}
          datepickerProps={{
            showYearDropdown: true,
            showMonthDropdown: true, 
            dropdownMode: "select",
            yearDropdownItemNumber: 10,
            minDate: new Date(startYear, 0, 1),
            maxDate: new Date(),
            renderYearContent: (year) => <>{year}</>,
            withPortal: true
          }}
        />
        
        <DateInput
          label="To"
          disabled={disabled}
          value={maximumDate}
          setValue={setMaximumDate}
          onChangeCommitted={(date) => {
            setFilters((prev) => ({
              ...prev,
              [label]: {
                comparator: FILTER_TYPE_TILL,
                keywords: [minimumDate, date],
              },
            }));
          }}
          datepickerProps={{
            showYearDropdown: true,
            showMonthDropdown: true,
            dropdownMode: "select",
            yearDropdownItemNumber: 10,
            minDate: new Date(startYear, 0, 1),
            maxDate: new Date(),
            renderYearContent: (year) => <>{year}</>,
            withPortal: true
          }}
        />
      </Box>
    </Box>
  );
};

export default SingleDateFilter;
